import { Switch } from 'react-router-dom'
import { CIMSModule, CIMSPage, CIMSPageItem, pathify, Permission } from 'shared'
import Snapshots from './components/Snapshots'
import UserSync from './components/UserSync'
import { ProtectedRoute } from '../../../../../components/ProtectedRoute'
import Developers from './components/Developers'

const Developer: React.FC = () => {
  const path = ({ pathname }: CIMSPageItem) =>
    pathify(CIMSModule.Developer.pathname, pathname)
  return (
    <Switch>
      <ProtectedRoute path={path(CIMSPage.DeveloperSnapshots)} developer>
        <Snapshots />
      </ProtectedRoute>
      <ProtectedRoute
        path={path(CIMSPage.UserSync)}
        permissions={Permission.SyncUsers}
      >
        <UserSync />
      </ProtectedRoute>
      <ProtectedRoute path={path(CIMSPage.Developers)} developer>
        <Developers />
      </ProtectedRoute>
    </Switch>
  )
}

export default Developer
